<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g fill="currentColor" fill-rule="nonzero">
            <path
                d="M25.291 27.29h6.05c1.721 0 2.81-.947 2.81-2.467 0-1.434-1.089-2.467-2.81-2.467h-6.05c-.2 0-.372.172-.372.345v4.243c.027.2.17.345.372.345zm0 9.777h6.251c1.921 0 3.068-.975 3.068-2.696 0-1.492-1.089-2.696-3.068-2.696h-6.251c-.2 0-.372.171-.372.345v4.675c.027.229.17.372.372.372z"
            />
            <path
                d="M47.428.106L29.534 17.942h2.925c4.56 0 7.255 2.867 7.255 5.992 0 2.467-1.663 4.273-3.441 5.076-.287.116-.287.516.029.63 2.063.804 3.526 2.954 3.526 5.476 0 3.556-2.38 6.394-6.997 6.394H20.158c-.2 0-.372-.171-.372-.345V27.66L.143 47.218c-.259.258-.087.716.287.716h47.227a.319.319 0 0 0 .316-.316V.364c.085-.316-.316-.487-.545-.258z"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "BigCommerceIcon",
};
</script>

<style scoped></style>
